import useIsMobileSize from 'src/hooks/useIsMobileSize';
import { DesktopLayout, WithoutHeader } from 'src/layout';
import { Wrapper, Container } from 'src/widgets/FeedFilter/SidebarShell';
import AIMonitoringBlock from 'src/widgets/FeedFilter/AIMonitoringBlock';
import { Paper, Typography, Box, Button } from '@mui/material';
import CollapsibleHintBlock from 'src/components/CollapsibleHintBlock';
import TelegramLogo from 'src/icons/TelegramLogo';

import Collections, { ICollectionProps } from './Content';

const ManagerBlock = () => {
    const handleContactManager = () => {
        window.open('https://t.me/tghunter_manager', '_blank');
    };

    return (
        <Paper
            elevation={0}
            sx={{
                p: 2,
                mt: 2,
                borderRadius: 2,
                background: '#fff',
                border: '1px solid #E3ECF3',
                boxShadow: 'none',
            }}
        >
            <Typography
                variant="h5"
                fontWeight={700}
                color="primary.main"
                sx={{ fontSize: 20, mb: 1 }}
            >
                Не нашли нужную подборку?
            </Typography>
            <Typography
                variant="body2"
                mb={2}
                sx={{ color: 'text.primary' }}
            >
                Обратитесь к нашему менеджеру в Telegram. Мы поможем найти подходящие чаты для вашего бизнеса.
            </Typography>
            <Button
                variant="outlined"
                startIcon={<TelegramLogo color="#0088CC" />}
                onClick={handleContactManager}
                fullWidth
                size="large"
                sx={{
                    borderColor: '#0088CC',
                    color: '#0088CC',
                    borderRadius: '16px',
                    backgroundColor: 'rgba(0, 136, 204, 0.08)',
                    '&:hover': {
                        borderColor: '#0088CC',
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    },
                }}
            >
                @tghunter_manager
            </Button>
        </Paper>
    );
};

export default function CollectionsScreen(props: ICollectionProps) {
    const isMobile = useIsMobileSize();

    if (isMobile) {
        return (
            <WithoutHeader showBack>
                <Collections {...props} />
            </WithoutHeader>
        );
    }

    return (
        <DesktopLayout
            rightSidebar={
                <Wrapper
                    elevation={0}
                    square={true}
                >
                    <Container
                        elevation={0}
                        isDisabled={false}
                    >
                        <AIMonitoringBlock />
                        <CollapsibleHintBlock
                            title="Как выбрать подборки чатов"
                            bullets={[
                                'Выберите тематические подборки — это набор чатов, которые сервис уже отслеживает.',
                                'Подборки регулярно обновляются и расширяются.',
                                'Можно выбрать несколько подборок для максимального охвата.',
                            ]}
                            example={[
                                'Например:',
                                'Если вы занимаетесь ремонтом — выберите подборки с жилыми комплексами, там пользователи могут спрашивать совета ремонтной бригады.',
                            ]}
                        />
                        <ManagerBlock />
                    </Container>
                </Wrapper>
            }
        >
            <Collections {...props} />
        </DesktopLayout>
    );
}
